import GravityBulkAdapter from 'teacher-ui-client/adapters/gravity/bulk-adapter'
import config from 'teacher-ui-client/config/environment'
import { service } from '@ember/service'
import { join } from 'teacher-ui-client/utils/uri'
import type SessionService from 'teacher-ui-client/services/session'
import { assert } from '@ember/debug'

export default class StudentAdapter extends GravityBulkAdapter {
  @service session!: SessionService

  urlForQuery() {
    const { currentSchool } = this.session

    assert('currentSchool.id missing', currentSchool?.id)

    return join(config.gravityV3Url, 'schools', currentSchool.id, 'students').toString()
  }
}
